import api from '../base';
import { Address, AddressType } from './addressApiTypes';
import { mockGetBillingAddress, mockGetDeliveryAddress } from './addressMock';

const BASE_PATH = 'management/addresses';

export async function getAddress(
  orderId: number,
  addressType: AddressType,
  signal?: AbortSignal,
): Promise<Address> {
  return api.get<Address>(`${BASE_PATH}/${orderId}/${addressType}`, {
    signal,
  })
    .then(response => response.data);
}

api.mock
  .onGet(/management\/addresses\/\d+\/DELIVERY|LAST_MILE/)
  .reply(200, mockGetDeliveryAddress);

api.mock
  .onGet(/management\/addresses\/\d+\/BILLING/)
  .reply(200, mockGetBillingAddress);

export async function updateAddress(
  orderId: number,
  addressType: AddressType,
  address: Omit<Address, 'id'>,
  signal?: AbortSignal,
): Promise<null> {
  return api.put<null>(`${BASE_PATH}/${orderId}/${addressType}`, address, {
    signal,
  })
    .then(response => response.data);
}

api.mock
  .onPut(/management\/addresses\/\d+\/.+/)
  .reply(204);
